<template>
  <div
    :id="`accordion-${id}`"
    class="accordion accordion-flush"
  >
    <div class="accordion-item">
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          type="button"
          data-bs-toggle="collapse"
          :data-bs-target="`#flush-collapse-1-${id}`"
          aria-expanded="true"
          aria-controls="flush-collapseOne"
        >
          {{ capitalizeFirstLetter($tc('words.generalInformations')) }}
        </button>
      </h2>
      <div
        :id="`flush-collapse-1-${id}`"
        class="accordion-collapse collapse show"
      >
        <div class="accordion-body">
          <ResourceMetaData
            :is-main="isMain"
            :form-config="formConfig"
            :resource="resource"
          />
        </div>
      </div>
    </div>
    <div
      v-if="isMain && (resource.isGeospatial() ||(!resource.isGeoserver() && resource.hasGeographicLayer()))"
      class="accordion-item"
    >
      <h2 class="accordion-header">
        <button
          class="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          :data-bs-target="`#flush-collapse-2-${id}`"
          aria-expanded="false"
          aria-controls="flush-collapseTwo"
        >
          {{ capitalizeFirstLetter($tc('words.geographicalLayer')) }}
        </button>
      </h2>
      <div
        :id="`flush-collapse-2-${id}`"
        class="accordion-collapse collapse"
      >
        <div class="accordion-body">
          <ResourceGeographicalLayer
            :key="`resource-geographical-layer-form-${resource.id}`"
            :resource="resource"
            :form-config="formConfig"
            :codename-disabled="true"
            :show-x-y="false"
          />
        </div>
      </div>
    </div>
    <div class="accordion-item">
      <h2 class="accordion-header">
        <button
          class="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          :data-bs-target="`#flush-collapse-3-${id}`"
          aria-expanded="false"
          aria-controls="flush-collapseThree"
        >
          {{ capitalizeFirstLetter($tc('words.dataSchema')) }}
        </button>
      </h2>
      <div
        :id="`flush-collapse-3-${id}`"
        class="accordion-collapse collapse"
      >
        <div class="accordion-body">
          <ResourceDataSchema
            :key="`${isMain ? 'resource' : 'annexe'}-data-schema`"
            :resource="resource"
          />
        </div>
      </div>
    </div>
    <div
      v-if="isWMSStyleAvailable && isMain && resource.hasGeographicLayer()"
      class="accordion-item"
    >
      <h2 class="accordion-header">
        <button
          class="accordion-button collapsed"
          type="button"
          
          data-bs-toggle="collapse"
          :data-bs-target="`#flush-collapse-4-${id}`"
          aria-expanded="false"
          aria-controls="flush-collapseFour"
          @click="$refs.WMSComponent.setActiveStyle()"
        >
          <div>
            <div style="width: 100%;">
              {{ $t('resource.accordion.style.label') }}
            </div>
            <div style="font-size: 0.85rem; color: #747c84; font-style: italic; margin-top: .5rem;">
              {{ $t('resource.accordion.style.help') }}
            </div>
          </div>
        </button>
      </h2>
      <div
        :id="`flush-collapse-4-${id}`"
        class="accordion-collapse collapse"
      >
        <div
          class="accordion-body"
          :style="{
            padding: 0
          }"
        >
          <ResourceWMSStyle ref="WMSComponent" :resource="resource"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState} from 'vuex';


import {
  ResourceDataSchema,
  ResourceGeographicalLayer,
  ResourceMetaData
} from '@/app/resource/components';
import ResourceWMSStyle from '@/components/Resource/ResourceWMSStyle.vue';

const MAPS_WC_AVAILABLE = process.env.VUE_APP_MAPS_WC_AVAILABLE === 'true';

export default {
  name: 'ResourceAccordion',

  components: {
    ResourceDataSchema,
    ResourceGeographicalLayer,
    ResourceMetaData,
    ResourceWMSStyle
  },

  props: {
    id: {
      type: Number,
      default: 1
    },
    isMain: {
      type: Boolean,
      default: true
    },
    formConfig: {
      type: Object,
      default: () => {}
    },
    resource: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      isWMSStyleAvailable: MAPS_WC_AVAILABLE
    };
  },

  computed: {
    ...mapState('datasets', [
      'currentDataset'
    ]), 
  },


  beforeRouteLeave(to, from, next) {
    const webcomponent = document.getElementById('webcomponent');
    const mapComponent = webcomponent.vueComponent;
    if (mapComponent && this.resource.hasGeographicLayer() && this.resource.geographicLayer && this.resource.geographicLayer.layerName) {
      mapComponent.removeLayerFromMap(this.resource.geographicLayer.layerName);
    }
    next();
  },

  methods: {

  }
};
</script>

<style lang="less">
.accordion-button:not(.collapsed) {
  color: inherit;
}
.accordion-header {
  .accordion-button {
    font-weight: 700 !important;
    background-color: #0074cc16 !important;
  }
  .accordion-button:not(.collapsed) {
    color: inherit;
  }
}
.accordion-body {
  padding-left: 5px;
  background-color: #eff3f52d;
}
</style>